<template>
  <p class="error-notification" v-if="error_message" v-text="error_message"></p>
</template>

<script>
import { mapState } from "vuex";
import { head } from "lodash";
import HasTranslatedText from "../../mixins/HasTranslatedText";

export default {
  mixins: [HasTranslatedText],

  computed: {
    ...mapState({
      errors: state => state.registration.errors,
    }),

    error_message() {
      if (this.errors.generic) {
        return head(this.errors.generic);
      }

      if (Object.keys(this.errors).length) {
        return this.translations.formRegistrationErrorText;
      }

      return "";
    },
  },
};
</script>
